export default __webpack_public_path__ + "static/media/BOOK 56682 - Barra de carga stacker 2.9efd6246.pdf";